export function searchTracking(type, inputType, data) {
    let result = {};
    if(inputType === 'Start / Ortssuche') result.action = 'Starting Point';
    if(inputType === 'Ziel') result.action = 'Destination';
    if(inputType === 'Zwischenziel') result.action = 'Stop';
    
    if(type === 'HOME') {
        if(data) {
            result.label = 'Home';
        } else {
            result.label = 'Add Home Address';
        }
    }

    else if (type === 'WORK') {
        if(data) {
            result.label = 'Work';
        } else {
            result.label = 'Add Work Address';
        }

    }

    else if (type === 'ROUTE') {
        result.label = 'Search History Route';
        if(inputType === 'Start') result.action = 'Search Location';
    }

    else if (type === 'FAVOURITES') {
        result.label = 'Favorites';
    }

    else if (type === 'HISTORY') {
        result.label = 'Search History';
    }

    else if (type === 'SEARCH') {
        result.label = 'Search Result';
    }

    else if (type === 'LOCATION') {
        result.label = 'Current Position';
    }

    return result;
}

export function ga4SearchTracking(type, inputType, data) {
    let result = {};
    if(inputType === 'Start / Ortssuche') result.name = 'starting_point';
    if(inputType === 'Ziel') result.name = 'destination';
    if(inputType === 'Zwischenziel') result.name = 'middle_point';
    switch(type) {
        case 'LOCATION':
          result.value = 'current_location';
          break;
        case 'FAVOURITES':
            result.value = 'favorites';
            break;
        case 'SEARCH':
            result.value = 'search_result';
            break;
        case 'HISTORY':
            result.value = `search_history_${result.name}`; 
            break;
        case 'ROUTE':
            result.value = 'search_history_route';
            break;
        case 'HOME':
          if(data) result.value = 'home';
          else result.value = 'add_home_address'
          break;
        case 'WORK':
          if(data) result.value = 'work';
          else result.value = 'add_work_address'
          break;
      }

    return result;
}

export function poiSorting(type, data) {
    let result = {};
    if(type.includes('carParks')) result.category = 'Parking'
    else if(type.includes('gasStations')) {
        result.category = 'Gas Stations';
        result.eventName = 'gas_station';
    }
    else if(type.includes('favourites')) {
        result.category = 'Favorites'
        result.eventName = 'favorites';
    }
    else if(type.includes('partners')) {
        result.category = 'partner'
        result.eventName = 'partner';
    }
    else if(type.includes('greenzone')) {
        result.category = 'Environmental Zone'
        result.eventName = 'environmental_zone'
    }
    else if(type.includes('roadHouses')) {
        result.category = 'Service Station';
        result.eventName = 'service_station'
    }
    else if(type.includes('nearbyStations')) {
        result.category = 'Stations'
        result.eventName = 'station'
    }
    else if(type.includes('camping')) {
        result.category = 'Camping' 
        result.eventName = 'camping'
    }
    else if(type.includes('passRoads')) {
        result.category = 'Mountain Road'
        result.eventName = 'mountain_road'
    }
    else if(type.includes('traffic')) {
        result.category = 'Traffic'
        result.eventName = 'traffic'
    }
    else if(type.includes('oeamtcLocations')) {
        result.category = 'ÖAMTC Offices'
        result.eventName = 'oeamtc_office'
    }
    else if(type.includes('travelRadar')) {
        result.category = 'Travel Warning'
        result.eventName = 'travel_warning'
    }

    result.action = 'Sort';
    result.name = 'order';

    if(data === 'DISTANCE_ASC') result.label = 'Distance';
    else if (data === 'NAME_ASC') result.label = 'Alphabetical'  ;
    else if(data === 'PRICE_ASC')  result.label = 'Price';  
    return result;
}

export function moreActionsTracking(type, event, favourites = false, name = false) {
    let result = {};
    if(type === 'savedRoutes') {
        result.ga4Event = 'favorite_routes';
        result.category = 'Favorites';
        result.action = 'Favorite Routes';

        if(event === 'edit') {
            result.label = 'Edit';
            result.ga4Parameter1Name = 'edit_poi';
            result.ga4Parameter1Value = 'edit_favorite_routes';
        } else if(event === 'traffic-alert') {
            result.label = 'Set Traffic Alert';
            result.ga4Parameter1Name = 'options';
            result.ga4Parameter1Value = 'set_traffic_alert';
        } else if(event === 'remove') {
            result.label = 'Delete';
            result.ga4Parameter1Name = 'delete_poi';
            result.ga4Parameter1Value = 'delete_favorite_routes';
        }
    }

    if(type === 'Arbeit') {
        result.category = 'Favorites'
        result.action = 'Work'
        if(event === 'editFavourite') {
            result.label = 'Edit';
            result.ga4Parameter1Name = 'edit_poi';
            result.ga4Parameter1Value = 'edit_work';
        }
    }

    if(type === 'Zuhause') {
        result.category = 'Favorites'
        result.action = 'Home'
        if(event === 'editFavourite') {
            result.label = 'Edit';
            result.label = 'Edit';
            result.ga4Parameter1Name = 'edit_poi';
            result.ga4Parameter1Value = 'edit_home';
        }
    }

    if(type === 'Routes') {
        result.ga4Event = 'favorites'
        result.category = 'Favorites'
        result.action = 'Favorite Routes'
        if(event === 'editFavourite') { 
            result.label = 'Edit';
            result.ga4Parameter1Name = 'edit_poi';
            result.ga4Parameter1Value = 'edit_' + getFavoritePOITrackingValue(name);
        }
    }
    
    if(favourites && type === 'searchLocation') { 
        result.category = 'Route Planner';
        result.action = 'Search Location';
        result.label = 'Save';
        result.ga4Parameter1Name = 'options';
        result.ga4Parameter1Value = 'save';
        result.ga4Event = 'selected_location';
    }

    if(favourites && type === 'carParks') {
        result.category = 'Parking';
        result.action = 'Options';
        result.label = 'Save';
        result.ga4Parameter1Name = 'options';
        result.ga4Parameter1Value = 'save';
        result.ga4Event = 'parking';
    }

    if(favourites && type === 'gasStations') {
        result.category = 'Gas Stations';
        result.action = 'Options';
        result.label = 'Save';
        result.ga4Parameter1Name = 'options';
        result.ga4Parameter1Value = 'save';
        result.ga4Event = 'gas_station';
    }

    if(favourites && type === 'partners') {
        result.category = 'Partners';
        result.action = 'Options';
        result.label = 'Save';
        result.ga4Parameter1Name = 'options';
        result.ga4Parameter1Value = 'save';
        result.ga4Event = 'partner';
    }

    if(favourites && type === 'roadHouses') {
        result.category = 'Service Station';
        result.action = 'Options';
        result.label = 'Save';
        result.ga4Parameter1Name = 'options';
        result.ga4Parameter1Value = 'save';
        result.ga4Event = 'service_station';
    }

    if(favourites && type === 'nearbyStations') {
        result.category = 'Stations';
        result.action = 'Options';
        result.label = 'Save';
        result.ga4Parameter1Name = 'options';
        result.ga4Parameter1Value = 'save';
        result.ga4Event = 'station';
    }

    if(favourites && type === 'camping') {
        result.category = 'Camping';
        result.action = 'Options';
        result.label = 'Save';
        result.ga4Parameter1Name = 'options';
        result.ga4Parameter1Value = 'save';
        result.ga4Event = 'camping';
    }

    if(favourites && type === 'passRoads') {
        result.category = 'Mountain Road';
        result.action = 'Options';
        result.label = 'Save';
        result.ga4Parameter1Name = 'options';
        result.ga4Parameter1Value = 'save';
        result.ga4Event = 'mountain_road';
    }

    if(favourites && type === 'oeamtcLocations') {
        result.category = 'ÖAMTC Offices';
        result.action = 'Options';
        result.label = 'Save';
        result.ga4Parameter1Name = 'options';
        result.ga4Parameter1Value = 'save';
        result.ga4Event = 'oeamtc_office';
    }

    if(favourites && type === 'sights') {
        result.category = 'Sights';
        result.action = 'Options';
        result.label = 'Save';
        result.ga4Parameter1Name = 'options';
        result.ga4Parameter1Value = 'save';
        result.ga4Event = 'sights';
    }

    if(favourites && type === 'tollRoads') {
        result.category = 'Toll';
        result.action = 'Options';
        result.label = 'Save';
        result.ga4Parameter1Name = 'options';
        result.ga4Parameter1Value = 'save';
        result.ga4Event = 'toll';
    }

    if(favourites && type === 'tunnels') {
        result.category = 'Tunnel';
        result.action = 'Options';
        result.label = 'Save';
        result.ga4Parameter1Name = 'options';
        result.ga4Parameter1Value = 'save';
        result.ga4Event = 'tunnel';
    }

    if(favourites && type === 'chargingStations') {
        result.category = 'Charging Station';
        result.action = 'Options';
        result.label = 'Save';
        result.ga4Parameter1Name = 'options';
        result.ga4Parameter1Value = 'save';
        result.ga4Event = 'charging_station';
    }

    return result;
}

export function poiTracking(selectedPOIs, category, position, type) {
    let result = {};
    
    if(selectedPOIs.includes('favourites')) {
        result.category = 'Favorites';
        result.ga4Event = 'favorites';

        if(category === 'Arbeit') {
            result.action = 'Work'; 
            result.ga4Parameter1Value = 'work';
        }
        else if(category === 'Zuhause') {
            result.action = 'Home';
            result.ga4Parameter1Value = 'home';
        }
        else result.action = 'Favorite Routes';

        result.ga4Parameter1Value = getFavoritePOITrackingValue(type);
    }

    if(position === 'start') {
        result.label = 'Set as Starting Point';
        result.ga4Parameter1Name = 'starting_point';
    } else if(position === 'end') {
        result.label = 'Set as Destination'
        result.ga4Parameter1Name = 'destination';
    } else if(position === 'between') {
        result.label = 'Set as Stop'
        result.ga4Parameter1Name = 'middle_point';
    }

    if(selectedPOIs.includes('carParks')) {
        result.category = 'Parking';
        result.action = 'Route';
        result.ga4Event = 'parking';
        result.ga4Parameter1Value = 'parking';
    }

    if(selectedPOIs.includes('gasStations')) {
        result.category = 'Gas Stations';
        result.action = 'Route';
        result.ga4Event = 'gas_station';
        result.ga4Parameter1Value = 'gas_station';
    }

    if(selectedPOIs.includes('partners')) {
        result.category = 'Partners';
        result.action = 'Route';
        result.ga4Event = 'partner';
        result.ga4Parameter1Value = 'partner';
    }

    if(selectedPOIs.includes('roadHouses')) {
        result.category = 'Service Station';
        result.action = 'Route';
        result.ga4Event = 'service_station';
        result.ga4Parameter1Value = 'service_station';
    }

    if(selectedPOIs.includes('nearbyStations')) {
        result.category = 'Stations';
        result.action = 'Route';
        result.ga4Event = 'station';
        result.ga4Parameter1Value = 'station';
    }

    if(selectedPOIs.includes('camping')) {
        result.category = 'Camping';
        result.action = 'Route';
        result.ga4Event = 'camping';
        result.ga4Parameter1Value = 'camping';
    }

    if(selectedPOIs.includes('passRoads')) {
        result.category = 'Mountain Road';
        result.action = 'Route';
        result.ga4Event = 'mountain_road';
        result.ga4Parameter1Value = 'mountain_road';
    }

    if(selectedPOIs.includes('oeamtcLocations')) {
        result.category = 'ÖAMTC Offices';
        result.action = 'Route';
        result.ga4Event = 'oeamtc_office';
        result.ga4Parameter1Value = 'oeamtc_office';
    }

    if(selectedPOIs.includes('sights')) {
        result.category = 'Sights';
        result.action = 'Route';
        result.ga4Event = 'sights';
        result.ga4Parameter1Value = 'sights';
    }

    if(selectedPOIs.includes('tollRoads')) {
        result.category = 'Toll';
        result.action = 'Route';
        result.ga4Event = 'toll';
        result.ga4Parameter1Value = 'toll';
    }

    if(selectedPOIs.includes('chargingStations')) {
        result.category = 'Charging Station';
        result.action = 'Route';
        result.ga4Event = 'charging_station';
        result.ga4Parameter1Value = 'charging_station';
    }

    if(selectedPOIs.includes('travelRadar')) {
        result.ga4Event = 'travel_warning';
        result.ga4Parameter1Value = 'travel_warning';
    }
    
    return result;
}

export function getFavoritePOITrackingValue (type) {
    switch(type) {
        case 'carParks':
          return 'parking';
        case 'gasStations':
            return 'gas_stations';
        case 'partners':
            return 'partner';
        case 'traffic':
            return 'traffic';
        case 'chargingStations':
            return 'charging_stations';
        case 'environmentalZones':
            return 'environmental_zone';
        case 'nearbyStations': 
            return 'stations';
        case 'sights':
            return 'sights';
        case 'oeamtcLocations':
            return 'oeamtc_offices';  
        case 'serviceStations':
            return 'service_station';
        case 'tollRoads':
            return 'toll'; 
        case 'tunnels':
            return 'tunnel';
        case 'passRoads':
            return 'mountain_road';  
        case 'camping':
            return 'camping'; 
        case 'travelRadar':
            return 'travel_warning';                
      }
}

export function poiDetailsTracking(eventName, label, value) {
    const result = {};
    // if(category) result.ga4Event =  category === 'Stations' ? 'station' : category.replace(/ /g, "_").toLowerCase();
    result.ga4Event = eventName
    result.ga4Parameter1Name = 'select_poi';
    if(value && (value ==='travel_warning' || value === 'station' || value === 'oeamtc_office')) result.ga4Parameter1Value = value
    else  result.ga4Parameter1Value = label ? label.replace(/ /g, "_").toLowerCase() : '-';
    return result; 
}